import React from "react";

/** 4열 KV 테이블(라벨·값 × 2) — 15% · 35% · 15% · 35% */
export function AssetDetailKvColgroupFour() {
    return (
        <colgroup>
            <col className="asset-detail-kv-col-label" style={{width: "15%"}} />
            <col className="asset-detail-kv-col-value" style={{width: "35%"}} />
            <col className="asset-detail-kv-col-label" style={{width: "15%"}} />
            <col className="asset-detail-kv-col-value" style={{width: "35%"}} />
        </colgroup>
    );
}
